module.exports = __webpack_public_path__ + "img/haft-poznan-10.daae08cb.jpg";